import React, { useContext } from 'react'

import Button from '../shared/Buttons/Button'
import { LoopContext, ShopifyContext } from '../Layout'
import { navigate } from 'gatsby'

export const ADD_TO_CART_BUTTON_HEIGHT = '64px'

const AddToCart = React.forwardRef((props, ref) => {
  const { clearCart } = useContext(ShopifyContext)
  const { createOrUpdateLoopCart, isLoopCart } = useContext(LoopContext)

  async function navigateToLoop(variantIds) {
    await createOrUpdateLoopCart(variantIds, clearCart)
  }
  const {
    cartOpen,
    toggleCart,
    setCartHasItems,
    addItem,
    ...rest
  } = useContext(ShopifyContext)

  const {
    title,
    shopifyId,
    amount = 1,
    cartUrl,
    isSelectOptions = false,
    tryNow = false,
    availableForSale = true,
    productType,
    convertedCompareAtPrice = null,
    convertedPrice = null,
    convertedCurrency,
    buyNow,
    cancelToggleCart,
  } = props

  const addToCartHandler = async ({
    shopifyId,
    amount,
    tryNow,
    cartUrl,
    convertedPrice,
    convertedCompareAtPrice,
    convertedCurrency,
  }) => {
    addItem({
      variantId: shopifyId,
      quantity: amount,
      tryNow,
      productType,
      onFinish: setCartHasItems,
      convertedPrice,
      convertedCompareAtPrice,
      convertedCurrency,
    })
      .then(
        res => {
          if (buyNow) {
            isLoopCart
              ? navigateToLoop(res.lineItems.map(li => li.variant.id))
              : navigate(res.webUrl)
          } else {
            !cancelToggleCart && toggleCart()
          }
          props.onFinish && props.onFinish()
        },
        rej => {
          console.error(rej)
        }
      )
      .catch(error => {
        throw new Error(error)
      })
  }

  return (
    <Button
      ref={ref}
      onClick={() => {
        addToCartHandler({
          shopifyId,
          amount,
          cartUrl,
          tryNow,
          convertedCurrency,
          convertedCompareAtPrice,
          convertedPrice,
        })
      }}
      disabled={!addItem || !availableForSale}
      {...props}
    >
      {!availableForSale ? 'OUT OF STOCK' : title}
    </Button>
  )
})

AddToCart.displayName = 'AddToCart'
export default AddToCart
